export const TID = {
  nav: {
    logo: "nav-logo",
    home: "nav-home",
    services: "nav-services",
    methodology: "nav-methodology",
    industries: "nav-industries",
    contact: "nav-contact",
    cta: "nav-cta-consult",
  },
  hero: {
    bookConsult: "hero-book-consultation-btn",
    requestAssessment: "hero-request-assessment-btn",
    uploadContract: "hero-upload-contract-btn",
  },
  form: {
    fullName: "form-full-name",
    companyName: "form-company-name",
    jobTitle: "form-job-title",
    phone: "form-phone",
    email: "form-email",
    industry: "form-industry",
    employees: "form-employees",
    location: "form-location",
    priority: "form-priority",
    description: "form-description",
    fileInput: "form-file-input",
    dropzone: "form-dropzone",
    consent: "form-consent",
    submit: "form-submit-btn",
    serviceCheckbox: (s) => `service-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
  },
  chat: {
    fab: "chat-widget-fab",
    panel: "chat-widget-panel",
    input: "chat-widget-input",
    send: "chat-widget-send",
    close: "chat-widget-close",
    openForm: "chat-widget-open-form",
  },
  admin: {
    loginEmail: "admin-login-email",
    loginPassword: "admin-login-password",
    loginSubmit: "admin-login-submit",
    logout: "admin-logout",
    inquiryRow: (id) => `inquiry-row-${id}`,
    inquiryView: (id) => `inquiry-view-${id}`,
    statsTotal: "admin-stats-total",
  },
  finalCta: {
    book: "final-cta-book",
    assessment: "final-cta-assessment",
    upload: "final-cta-upload",
    call: "final-cta-call",
  }
};

export default TID;
